import { graphql } from 'gatsby'
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import React from 'react'
import { Layout } from '../components'
import '../styles/project-details.scss'
const ProjectDetails = ({ data }) => {
    const { html } = data.markdownRemark
    const { stack, title, featured } = data.markdownRemark.frontmatter;
    const featuredImage = getImage(featured)
    return (
        <Layout>
            <div className="details">
                <h2>{ title }</h2>
                <h3>{ stack }</h3>
                <div className="featured">
                    <GatsbyImage image={featuredImage} alt={ title } />
                </div>
                <div className="html" dangerouslySetInnerHTML={{ __html: html }} />
            </div>
        </Layout>
    )
}
export const query = graphql`
query ProjectDetailPage($slug: String) {
    markdownRemark(frontmatter: {slug: {eq: $slug}}) {
      html
      frontmatter {
        stack
        title
        featured {
          childImageSharp {
            gatsbyImageData(
                placeholder: BLURRED
                formats: [PNG]
              )
          }
        }
      }
    }
  }
  `

export default ProjectDetails
